/**
 * @file Album related helper functions.
 */
import get from 'lodash.get';
import { defaultDataIdFromObject } from 'apollo-cache-inmemory';

import { AlbumForReview } from '../graphql/fragments/album';
import { AlbumFolderForReviewDetails } from '../graphql/fragments/album-folder';

/**
 * Updates the Apollo Store accordingly after a photo
 * has been published from Review.
 *
 * @param {Album} album Album for which a photo was published.
 * @param {*} store Apollo Store cache.
 * @param {number} photosCount Number of photos modified.
 */
const updateStoreAfterReview = (album, store, photosCount = 1) => {
  const albumFragment = store.readFragment({
    id: defaultDataIdFromObject(album),
    fragment: AlbumForReview,
  });

  albumFragment.photos_for_review.total -= photosCount;

  store.writeFragment({
    id: defaultDataIdFromObject(album),
    fragment: AlbumForReview,
    data: albumFragment,
  });

  const hierarchy = get(album, 'album_folder_hierarchy.records', []);

  // Update each albumFolder in hierarchy fragments:
  hierarchy.forEach(albumFolder => {
    try {
      const albumFolderFragment = store.readFragment({
        id: defaultDataIdFromObject(albumFolder),
        fragment: AlbumFolderForReviewDetails,
      });

      albumFolderFragment.photos_for_review.total -= photosCount;

      store.writeFragment({
        id: defaultDataIdFromObject(albumFolder),
        fragment: AlbumFolderForReviewDetails,
        data: albumFolderFragment,
      });
    } catch (error) {
      // Basically have this in case fragment is not yet in store
    }
  });
};

export { updateStoreAfterReview };
